<script setup lang="ts">
defineOptions({
	name: 'DataSubjectSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:settings-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Data Subject Rights and Contact') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t('Subject to applicable law (including GDPR and Portuguese Law No. 58/2019 and Law No.41/2004), you may')
				}}:
			</p>
			<ul class="list-disc pl-7 space-y-2.5">
				<li>{{ $t('Access your personal data processed via cookies') }}.</li>
				<li>{{ $t('Rectify inaccurate or incomplete data') }}.</li>
				<li>{{ $t('Request erasure of your data (right to be forgotten)') }}.</li>
				<li>{{ $t('Request restriction of processing') }}.</li>
				<li>{{ $t('Object to processing, including profiling and cookies used for analytics/marketing') }}.</li>
				<li>
					{{
						$t(
							'Receive your data in a portable format and/or request its transmission to another controller (where technically feasible)',
						)
					}}.
				</li>
				<li>
					{{
						$t(
							'Lodge a complaint with a supervisory authority, in particular the Comissão Nacional de Proteção de Dados (CNPD) ({link}) or another EU supervisory authority',
							{ link: 'www.cnpd.pt' },
						)
					}}.
				</li>
			</ul>
			<p>{{ $t('How to exercise your rights: Submit a request by') }}:</p>
			<ul class="list-none pl-7 space-y-2.5">
				<li>{{ $t('Email') }}: hello@lucky-wise.com</li>
				<li>{{ $t(`Cookie preferences: “Cookie Settings” link in the site footer`) }}</li>
			</ul>
		</div>
	</section>
</template>
